var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"d-flex align-items-center justify-content-between text-size-16 mb-2"},[_c('label',{staticClass:"text-left d-block mb-0 font-weight-bold"},[_vm._v("\n            "+_vm._s(_vm.label)+" :\n        ")]),_vm._v(" "),_c('div',[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }